export default /* glsl */ `vec4 mapUVWO(vec4 uvwo, vec4 stpq) {
  return uvwo;
}
`;
